var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ScrollSelect", {
    ref: "ScrollSelect",
    attrs: {
      api: _vm.api,
      placeholder: _vm.placeholder,
      multiple: _vm.multiple,
      disabled: _vm.disabled,
      size: _vm.size,
      "default-params": { lovCode: _vm.code },
      "default-options": _vm.defaultOptions,
      remote: _vm.remote,
      "no-data-text": _vm.noDataText,
      "search-key": "service",
      "option-label": "service",
      "option-value": "instanceId",
      "res-key": "content",
    },
    on: { change: _vm.onChange },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v
      },
      expression: "id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }